import React from 'react'
import PropTypes from 'prop-types'

function Table({banners, onEdit, onDelete}) {
  return <table className='table'>
    <thead>
      <tr>
        <th>Banner Name</th>
        <th>Region</th>
        <th className='modify'>Modify</th>
      </tr>
    </thead>
    <tbody>
      { 
        banners.map((banner, index) => {
          return <tr key={index}>
            <td>{banner.name}</td>
            <td>{banner.region_name}</td>
            <td>
              <div className='menu-buttons'>
                <button className='btn btn-primary' onClick={() => onEdit(banner)}>Edit</button>
                <button className='btn btn-danger' onClick={() => onDelete(banner)}>Delete</button>
              </div>
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}

Table.propTypes = {
  banners: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default Table

